import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
export const defaultTimezone = 'Europe/Moscow';
dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault(defaultTimezone);
dayjs.locale('ru')

export const datetimeFromUTC = (utcDate, keepLocalTime = false) => {
    const date = dayjs(utcDate).tz(defaultTimezone, keepLocalTime).format('DD.MM.YYYY');
    const time = dayjs(utcDate).tz(defaultTimezone, keepLocalTime).format('HH:mm');
    return { date, time };
}

export const datetimeShortFromUTC = (utcDate, keepLocalTime = false) => {
    const date = dayjs(utcDate).tz(defaultTimezone, keepLocalTime).format('DD.MM.YY');
    const time = dayjs(utcDate).tz(defaultTimezone, keepLocalTime).format('HH:mm');
    return { date, time };
}

export const dateRelativeFromUTC = (utcDate) => {
    const djs = dayjs(utcDate);
    if (djs.isToday()) { return 'Сегодня'; }
    if (djs.isYesterday()) { return 'Вчера'; }
    return djs.format('DD.MM.YYYY');
}

export const birthdayFormatFromUTC = (utcDate, keepLocalTime = false) => {
    return dayjs(utcDate).tz(defaultTimezone, keepLocalTime).format('YYYY-MM-DD');
}

export const buildTimesByDays = (utcDates) => {
    const hash = {};
    for (const utcDate of utcDates) {
        const { date, time } = datetimeFromUTC(utcDate);
        if (hash[date]) {
            if (hash[date].includes(utcDate)) { continue; }
            hash[date].push(utcDate);
        } else {
            hash[date] = [utcDate];
        }
    }
    return hash;
}

export const ticketFormat = (utcDate, keepLocalTime = false) => {
    const date = dayjs(utcDate).tz(defaultTimezone, keepLocalTime).format('DD MMM');
    const time = dayjs(utcDate).tz(defaultTimezone, keepLocalTime).format('HH:mm');
    return `${date}, ${time}`
}

export const getUTCDateFromString = (string, format = 'DD.MM.YYYY', keepLocalTime = true) => {
    return dayjs(string, format).tz(defaultTimezone, keepLocalTime).format();
}

export const isDateStringValid = (string, format = 'DD.MM.YYYY', keepLocalTime = false) => {
    return dayjs(string, format).tz(defaultTimezone, keepLocalTime).isValid();
}

export const dateWithLocalTime = (date, keepLocalTime = false) => {
    return dayjs(date).tz(defaultTimezone, keepLocalTime);
}
